/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('assets/glb-file/41.glb')
  const { actions } = useAnimations(animations, group)

  useEffect(() => {
    //actions['run'].play();
    actions['jump_rope'].play();
    //actions['jump'].play();
    //actions['idle'].play();
    //actions['aerobic_workout'].play();
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="RootNode0" scale={0.1}>
          <group name="geo1">
            <skinnedMesh name="fitness_character2" geometry={nodes.fitness_character2.geometry} material={nodes.fitness_character2.material} skeleton={nodes.fitness_character2.skeleton} />
          </group>
          <group name="skeletal3">
            <primitive object={nodes.Root4} />
          </group>
        </group>
      </group>
    </group>
  )
}

//useGLTF.preload('assets/glb-file/41.glb')
